export const toggleSidebar = () => {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('sidebar-enable')
}